import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Event_Public_Speaker_Table_data: {
    columns: [
      {
        label: 'Image',
        field: 'image',
        sort: 'asc'
      },
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Designation',
        field: 'designation',
        sort: 'asc'
      },
      {
        label: 'LinkedIn Profile URL',
        field: 'linkedInUrl',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
  },
  systemUser: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'User Role',
        field: 'role',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  Agenda_Table_data: {
    columns: [
      {
        label: 'Index',
        field: 'Index',
        sort: 'asc'
      },
      {
        label: 'Title',
        field: 'title',
        sort: 'asc'
      },
      {
        label: 'Start Time',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Time',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ]
  },
  EventPublicSpeakerData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_EVENT_PUBLIC_SPEAKER:
      return {
        ...state,
        // receptionData: action.value
      };
    default:
      return state;
  }
};

export default reducer;
